import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputMask} from 'primereact/inputmask';
import {Calendar} from 'primereact/calendar';
import moment from 'moment';

const ExchangerateFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [currency, setCurrency] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().exchangerateId) || (entity === 'exchange-rate' && id)) {
      apiCall('patch', '/api/v2/exchange-rate/' + (window.App.urlVars().exchangerateId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderExchangerateList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/exchange-rate', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderExchangerateList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/finance/exchange-rate/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().exchangerateId) || (entity === 'exchange-rate' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/exchange-rate/' + (window.App.urlVars().exchangerateId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrency(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  return (
    <div className={"exchangerate-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            
             <div className={"p-col-12 p-lg-6"}>
                <Field name="currency" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="currency"
                            className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                    <span className={"p-d-block"}>
                                <Dropdown {...input}
                                          onChange={(e) => {
                                            setFormData({
                                              ...formData,
                                              currency: e.target.value
                                            })
                                            setNewFormData({
                                              ...newFormData,
                                              currency: e.target.value
                                            })
                                          }}
                                          value={formData.currency}
                                          options={window.App.sortDropdownOptions(currency, "key")}
                                          optionLabel="key"
                                          optionValue="key"
                                          id={"currency"}
                                          emptyMessage={t('noCurrencyYet')}
                                          className={classNames({'p-error': isFormFieldValid(meta)})}
                                />
                              </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>

              <div className={"p-col-12 p-lg-6"}>
              <Field name="rate" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="rate"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRate')}</label>
                  <span className="p-d-block">
                      <InputText id="rate" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     rate: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     rate: e.target.value
                                   })
                                 }}
                                 value={formData.rate}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="date" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="date"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDate')}</label>
                  <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date"}
                                        mask={"9999-99-99"}
                                        placeholder={t('datePlaceholder')}
                                        value={formData.date}
                                        onChange={(e) => {
                                          if (e.value.indexOf("_") === -1) {
                                            if (e.value === '') {
                                              e.value = null
                                            }
                                            setFormData({
                                              ...formData,
                                              date: e.value
                                            })
                                            setNewFormData({ ...newFormData, date: e.value });
                                          }
                                        }}
                            />
                            <Calendar value={formData.date}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                        setNewFormData({ ...newFormData, date: moment.utc(e.value).local().format('YYYY-MM-DD') });
                                      }}/>
                          </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'exchange-rate' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ExchangerateFormComponent);
